var render = function render(){var _vm=this,_c=_vm._self._c;return _c('patient-index',{on:{"handleView":_vm.handleView}})
}
var staticRenderFns = []

export { render, staticRenderFns }